/**
 * Palette lanes — the readability contract for geometric art:
 * - Background/props: near-black, low saturation. Never competes with bullets.
 * - Enemy bullets: HOT lane (magenta/orange, white cores), always rendered
 *   above player effects — they are the information.
 * - Player effects: COOL lane (cyan/teal).
 * - Pickups/UI accents: green/gold, used nowhere else.
 */
export const Palette = {
  bg: 0x0a0c14,
  floor: 0x121622,
  floorAlt: 0x151a29,
  wall: 0x272e44,
  wallEdge: 0x3a4260,

  enemyHot: 0xff2d78,
  enemyHotAlt: 0xff9a3d,
  enemyBody: 0xa8365c,
  enemyBodyAlt: 0xb06a3a,
  bulletCore: 0xffffff,

  playerCool: 0x3df2ff,
  playerCoolSoft: 0x9df7ff,

  gem: 0x59f28b,
  gold: 0xffd76a,

  telegraph: 0xff2d78,
  danger: 0xff4d4d,
  /** ME4 debris rework (2026-07-28): falling rubble reads BROWN, never the
   *  pink telegraph lane — background-class, no HOT collision. */
  debris: 0x8f5b2f,
  debrisDeep: 0x5c3a1d,

  hudText: 0xd8e0f0,
  hudDim: 0x6b7694,
  hudPanel: 0x10141f,
  focus: 0x3df2ff,
} as const;

/** Artifact proc accent colors — shared by every artifact-listing UI. */
export const PROC_COLOR = {
  none: Palette.gold,
  cursed: Palette.enemyHot,
  blessed: Palette.playerCool,
} as const;
